export default __webpack_public_path__ + "static/media/appleLogo.d62ec86d.png";